export default __webpack_public_path__ + "static/media/search_icon_red.aafd61de.svg";